import { render, staticRenderFns } from "./DateTimeColumn.vue?vue&type=template&id=48f4f383"
import script from "./DateTimeColumn.vue?vue&type=script&lang=js"
export * from "./DateTimeColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports